import '../../../table/table.less';

// import WithCoreProps from '../../../../../hocs/withCoreProps';
import { WithCoreProps } from 'ff-shared-components-core';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Total } from '../../../table/types';

export interface TotalsRowProps {
	/**Set totals*/
	totals?: Total[];
}

type Props = TotalsRowProps & RouteComponentProps;

class TotalsRowComponent extends React.PureComponent<Props> {
	render(): React.ReactNode {
		const { totals } = this.props;
		return (
			<>
				<li className="ds-table-cell ds-table-cell-total">
					<div className="ds-table-cell-detail flex-column table-extra-big-cell table-total">
						<span>Total</span>
					</div>
					{totals &&
						totals.map(
							(total: Total, index: number): JSX.Element => (
								<React.Fragment key={total.id || index}>
									<div className={`ds-table-cell-detail flex-column table-normal-currency-cell`}>
										{total.month && <span className="ds-table-hide">Total {total.month} </span>}
										<span>{total.value}</span>
									</div>
								</React.Fragment>
							)
						)}
					<div className="ds-table-cell-detail flex-column clickable table-small-cell"></div>
				</li>
			</>
		);
	}
}

export const TotalsRow = WithCoreProps<TotalsRowProps>(withRouter(TotalsRowComponent));
